import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import LinkContainer from 'react-router-bootstrap/LinkContainer';
import Nav from 'react-bootstrap/Nav';
import Badge from 'react-bootstrap/Badge';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Store } from './Store.js';
import { useSocket } from './SocketContext';

import HomeScreen from './screens/HomeScreen.js';
import { Link } from 'react-router-dom';
import CartScreen from './screens/CartScreen.js';
import SignupScreen from './screens/SignupScreen';
import OrderHistory from './screens/OrderHistory';
import OrderScreen from './screens/OrderScreen';
import ProfileScreen from './screens/ProfileScreen';
import ManagerReportScreen from './screens/ManagerReportScreen';
import Button from 'react-bootstrap/Button';
import { getError } from './utils';
import axios from 'axios';
import SearchBox from './components/SearchBox';
import SearchScreen from './screens/SearchScreen';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardScreen from './screens/DashboardScreen';
import ProductEditScreen from './screens/ProductEditScreen';
import OrderListScreen from './screens/OrderListScreen';
import UserListScreen from './screens/UserListScreen';
import UserEditScreen from './screens/UserEditScreen';
import Report from './screens/IncomeStatment';
import SendReport from './screens/SendReport';
import ReportScreen from './screens/ReportScreen';
import ReportDashboard from './screens/ReportDashboard';
import Iyandikishe from './screens/Irandikishe';
import Kora from './screens/Kora';
import Expense from './screens/Expese';
import SeeReport from './screens/SeeReport';
import Special from './screens/Special';
import GetSpecial from './screens/GetSpecial';
import SearchForm from './screens/SearchDept';
import MyShop from './screens/MyShop';
import ExpensesByMonth from './screens/MonthyExpense';
import MomoPay from './screens/PayScreen.js';
import DigitalMenu from './screens/DigitalMenu';
import ManagerDashboard from './screens/ManagerDashboard';
import TableManagement from './screens/TableManagement';
import MenuManagement from './screens/MenuManagement';
import ProductListScreen from './screens/productListScreen.js';
import QRScanner from './screens/QRScanner';
import InventoryScreen from './screens/InventoryScreen';
import WorkerScreen from './screens/WorkerScreen';
import SellerRoute from './components/SellerRoute';
import AdminRoute from './components/AdminRoute';
import IncomeStatementScreen from './screens/IncomeStatementScreen';
import BalanceSheetScreen from './screens/BalanceSheetScreen';
import WaiterOrderScreen from './screens/WaiterOrderScreen';

function App() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { cart, userInfo } = state;
  const { socket } = useSocket();
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    if (socket) {
      const handleNewNotification = () => {
        setNotificationCount((prev) => prev + 1);
        // Optional: Play sound or show toast
        toast.info("New Kitchen Activity!");
      };

      socket.on('new_order', handleNewNotification);
      socket.on('new_feedback', handleNewNotification);

      return () => {
        socket.off('new_order', handleNewNotification);
        socket.off('new_feedback', handleNewNotification);
      };
    }
  }, [socket]);

  const clearNotifications = () => {
    setNotificationCount(0);
  };


  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    localStorage.removeItem('userInfo');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('paymentMethod');
    window.location.href = '/signin';
  };
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [categories, setCategories] = useState([]);

  //we committed this

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axios.get(`/api/products/categories`);
        if (Array.isArray(data)) {
          setCategories(data);
        } else {
          console.error('Expected array for categories but got:', data);
          setCategories([]);
        }
      } catch (err) {
        toast.error(getError(err));
      }
    };
    fetchCategories();
  }, []);

  return (
    <BrowserRouter>
      <div
        className={
          sidebarIsOpen
            ? 'd-flex flex-column site-container active-cont'
            : 'd-flex flex-column site-container'
        }
      >
        <ToastContainer position="bottom-center" limit={1} />
        <header>
          <Navbar
            style={{ backgroundColor: 'Green' }}
            variant="dark"
            expand="lg"
          >
            <Container>
              <Button
                variant="dark"
                onClick={() => setSidebarIsOpen(!sidebarIsOpen)}
              >
                <i className="fas fa-bars"></i>
              </Button>
              <LinkContainer to="/">
                <Navbar.Brand>
                  <img
                    src="/logo.png"
                    width={40}
                    height={40}
                    style={{ borderRadius: '50%' }}
                    alt="logo"
                  />
                </Navbar.Brand>
              </LinkContainer>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto w-100 justify-content-end ">
                  <Link to="/cart" className="nav-link">
                    <i className="fas fa-shopping-cart me-1"></i>
                    Your Order
                    {cart.cartItems.length > 0 && (
                      <Badge pill bg="danger" className="ms-1">
                        {cart.cartItems.reduce((a, c) => a + c.quantity, 0)}
                      </Badge>
                    )}
                  </Link>
                  {userInfo ? (
                    <NavDropdown title={userInfo.name} id="basic-nav-dropdown">
                      <LinkContainer to="/profile">
                        <NavDropdown.Item>Profile</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/orderhistory">
                        <NavDropdown.Item>My Orders</NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      {userInfo.isWaiter && (
                        <LinkContainer to="/waiter/order">
                          <NavDropdown.Item>Waiter Order Panel</NavDropdown.Item>
                        </LinkContainer>
                      )}
                      <Link
                        className="dropdown-item"
                        to="#signout"
                        onClick={signoutHandler}
                      >
                        Sign Out
                      </Link>
                    </NavDropdown>
                  ) : (
                    <Link className="nav-link" to="/signin">
                      Sign In
                    </Link>
                  )}
                  {userInfo && userInfo.isAdmin && (
                    <NavDropdown title="Admin" id="admin-nav-dropdown">
                      <LinkContainer to="/admin/dashboard">
                        <NavDropdown.Item>System Dashboard</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/reportSummary">
                        <NavDropdown.Item>Performance Summary</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/users">
                        <NavDropdown.Item>User Management</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/products">
                        <NavDropdown.Item>Back Office Products</NavDropdown.Item>
                      </LinkContainer>
                    </NavDropdown>
                  )}
                  {userInfo && userInfo.isSeller && (
                    <NavDropdown title="Manager" id="seller-nav-dropdown">
                      <LinkContainer to="/admin/manager-dashboard">
                        <NavDropdown.Item>Kitchen Display (KDS)</NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      <LinkContainer to="/admin/menu">
                        <NavDropdown.Item>Menu Management</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/tables">
                        <NavDropdown.Item>Tables & QR Codes</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/inventory">
                        <NavDropdown.Item>Inventory Management</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/workers">
                        <NavDropdown.Item>Worker Management</NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      <LinkContainer to="/admin/orders">
                        <NavDropdown.Item>Order History</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/report">
                        <NavDropdown.Item>Sales Reports</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/expenses">
                        <NavDropdown.Item>Expense Tracking</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/income-statement">
                        <NavDropdown.Item>Income Statement</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/balance-sheet">
                        <NavDropdown.Item>Balance Sheet</NavDropdown.Item>
                      </LinkContainer>
                    </NavDropdown>
                  )}
                  {userInfo && (userInfo.isAdmin || userInfo.isSeller) && (
                    <Link to="/admin/manager-dashboard" className="nav-link position-relative me-3" onClick={clearNotifications}>
                      <i className="fas fa-bell fa-lg"></i>
                      {notificationCount > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                          {notificationCount}
                          <span className="visually-hidden">unread messages</span>
                        </span>
                      )}
                    </Link>
                  )}
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </header>

        <div
          className={
            sidebarIsOpen
              ? 'active-nav side-navbar d-flex justify-content-between flex-wrap flex-column'
              : 'side-navbar d-flex justify-content-between flex-wrap flex-column'
          }
        >
          <Nav className="flex-column text-white w-100 p-2">
            <Nav.Item>
              <strong>Categories</strong>
            </Nav.Item>
            {categories.map((category) => (
              <Nav.Item key={category}>
                <LinkContainer
                  to={`/search?category=${category}`}
                  onClick={() => setSidebarIsOpen(false)}
                >
                  <Nav.Link>{category}</Nav.Link>
                </LinkContainer>
              </Nav.Item>
            ))}
          </Nav>
        </div>
        <main>
          <Container>
            <Routes>
              <Route path="/menu" element={<DigitalMenu />} />
              <Route path="/scan" element={<QRScanner />} />
              <Route path="/cart" element={<CartScreen />} />
              <Route path="/signin" element={<Iyandikishe />} />
              <Route path="/signup" element={<SignupScreen />} />
              <Route path="/special" element={<Special />} />
              <Route path="/reportReview" element={<SendReport />} />
              <Route path="/search" element={<SearchScreen />} />
              <Route path="/depts" element={<SearchForm />} />
              <Route path="/pay" element={<MomoPay />} />

              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <ProfileScreen />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/order/:id"
                element={
                  <OrderScreen />
                }
              />
              <Route
                path="/report/:id"
                element={
                  <ProtectedRoute>
                    <ReportScreen />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/update/:id"
                element={
                  <ProtectedRoute>
                    <ReportScreen />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/orderHistory"
                element={
                  <ProtectedRoute>
                    <OrderHistory />
                  </ProtectedRoute>
                }
              />

              {/*Admin Routes*/}
              <Route
                path="/admin/manager-dashboard"
                element={
                  <SellerRoute>
                    <ManagerDashboard />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/tables"
                element={
                  <SellerRoute>
                    <TableManagement />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/menu"
                element={
                  <SellerRoute>
                    <MenuManagement />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/products"
                element={
                  <AdminRoute>
                    <ProductListScreen />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/dashboard"
                element={
                  <AdminRoute>
                    <DashboardScreen />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/reportSummary"
                element={
                  <AdminRoute>
                    <ReportDashboard />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/special"
                element={
                  <SellerRoute>
                    <GetSpecial />
                  </SellerRoute>
                }
              />

              <Route
                path="/admin/createReport"
                element={
                  <SellerRoute>
                    <Kora />
                  </SellerRoute>
                }
              />

              <Route
                path="/manager/report"
                element={
                  <SellerRoute>
                    <ManagerReportScreen />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/users"
                element={
                  <AdminRoute>
                    <UserListScreen />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/expenses"
                element={
                  <SellerRoute>
                    <SeeReport />
                  </SellerRoute>
                }
              />

              <Route
                path="/admin/report"
                element={
                  <SellerRoute>
                    <Report />
                  </SellerRoute>
                }
              />

              <Route
                path="/admin/create"
                element={
                  <SellerRoute>
                    <Expense />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/myshop"
                element={
                  <SellerRoute>
                    <MyShop />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/monthly"
                element={
                  <SellerRoute>
                    <ExpensesByMonth />
                  </SellerRoute>
                }
              />

              <Route
                path="/admin/user/:id"
                element={
                  <AdminRoute>
                    <UserEditScreen />
                  </AdminRoute>
                }
              />

              <Route
                path="/admin/product/:id"
                element={
                  <SellerRoute>
                    <ProductEditScreen />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/orders"
                element={
                  <SellerRoute>
                    <OrderListScreen />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/inventory"
                element={
                  <SellerRoute>
                    <InventoryScreen />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/workers"
                element={
                  <SellerRoute>
                    <WorkerScreen />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/income-statement"
                element={
                  <SellerRoute>
                    <IncomeStatementScreen />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/balance-sheet"
                element={
                  <SellerRoute>
                    <BalanceSheetScreen />
                  </SellerRoute>
                }
              />
              <Route
                path="/admin/waiter-order"
                element={
                  <SellerRoute>
                    <WaiterOrderScreen />
                  </SellerRoute>
                }
              />
              <Route
                path="/waiter/order"
                element={
                  <ProtectedRoute>
                    <WaiterOrderScreen />
                  </ProtectedRoute>
                }
              />

              <Route path="/" element={<HomeScreen />} />
            </Routes>
          </Container>
        </main>
        <footer>
          <div className="text-center">all right reserved</div>
        </footer>
      </div>
    </BrowserRouter >
  );
}

export default App;
